import React from 'react';
import { DaySelector } from '@/components/DaySelector';
import { ActionBar } from '@/components/ActionBar';

export function ControlsSection({ 
  currentDate, 
  onDateChange, 
  calculateDailyDogCount, 
  onClearAll, 
  onCheckAll,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  selectedUser,
  onUserChange,
  onPdfUpload,
  onClearAllProfiles,
  dayDogs = [],
  completedDogs = {},
  selectedDayKey = '',
  requireConfirmation = false,
  profiles = [],
  isReadOnly = false,
  reorderUnlocked = false,
  setReorderUnlocked = null
}) {

  const handleGoToToday = () => {
    onDateChange(new Date());
  };

  return (
    <div className="flex flex-col items-center mb-0.5 gap-1.5">
      <div className="w-full">
        <DaySelector
          currentDate={currentDate}
          onDateChange={onDateChange}
          calculateDailyDogCount={calculateDailyDogCount}
        />
      </div>
      <div className="w-full mt-2">
      <ActionBar 
         onClearAll={onClearAll} 
         onCheckAll={onCheckAll} 
         onGoToToday={handleGoToToday}
         onDateChange={onDateChange}
         currentDate={currentDate}
         onUndo={onUndo}
         onRedo={onRedo}
         canUndo={canUndo}
         canRedo={canRedo}
         selectedUser={selectedUser}
         onUserChange={onUserChange}
         onPdfUpload={onPdfUpload}
         onClearAllProfiles={onClearAllProfiles}
         dayDogs={dayDogs}
         completedDogs={completedDogs}
         selectedDayKey={selectedDayKey}
         requireConfirmation={requireConfirmation}
         profiles={profiles}
         isReadOnly={isReadOnly}
         reorderUnlocked={reorderUnlocked}
         setReorderUnlocked={setReorderUnlocked}
       />
      </div>
    </div>
  );
}
